module.exports = __webpack_public_path__ + "static/img/rheinische_museen.c0400a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/rheinische_museen.png
// module id = oON6
// module chunks = 0